import { Component, OnInit, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { BaseComponent } from '@portals/core';
import { finalize, tap } from 'rxjs';
import { CollectiblesState, DashboardFilterData } from '@portals/store';
@Component({
	selector: 'portals-dashboard-channel-activity',
	templateUrl: './channel-activity.component.html',
	styleUrls: ['./channel-activity.component.scss'],
})
export class ChannelActivityComponent extends BaseComponent implements OnInit {
	@Input() projectID!: number;
	@Input() currentFilters: any;
	timeframe = 'yearly';
	data: { name: string; value: number; color: string }[] = [];
	maxValue = 0;
	minValue = 0;
	formLoading = false;
	notificationInfoData: any;
	durationData: any;
	constructor(public collectible: CollectiblesState, public cdr: ChangeDetectorRef) {
		super();
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes['currentFilters']) {
			const previousValue = changes['currentFilters'].previousValue;
			const currentValue = changes['currentFilters'].currentValue;

			if (!this.isEqual(previousValue, currentValue)) {
				this.fetchData(this.timeframe, currentValue);
				this.cdr.detectChanges();
			}
		}
	}
	private isEqual(obj1: any, obj2: any): boolean {
		return JSON.stringify(obj1) === JSON.stringify(obj2);
	}
	async fetchData(timeframe: string, filter: any) {
		this.formLoading = true;
		this.subscribe(
			this.collectible.getTopNotifications(this.projectID, timeframe, filter).pipe(
				tap((data) => {
					console.log(data);
					if (data.allNotification) {
						this.notificationInfoData = data.allNotification;
					} else {
						this.notificationInfoData = null;
					}
					if (data.infoData) {
						this.durationData = data.infoData;
					} else {
						this.durationData = null;
					}
				}),
				finalize(() => {
					this.formLoading = false;
				})
			)
		);
	}

	ngOnInit(): void {
		this.fetchData(this.timeframe, this.filterData);
	}
	convertData(inputData: any) {
		if (inputData !== undefined && inputData.audioData[0] !== undefined && inputData.videoData[0] !== undefined && inputData.textData[0] !== undefined) {
			return {
				audio: {
					project_id: inputData.audioData[0].project_id,
					count: inputData.audioData[0].count,
					average: inputData.audioData[0].average,
					max: inputData.audioData[0].max,
					min: inputData.audioData[0].min,
				},
				video: {
					project_id: inputData.videoData[0].project_id,
					count: inputData.videoData[0].count,
					average: inputData.videoData[0].average,
					max: inputData.videoData[0].max,
					min: inputData.videoData[0].min,
				},
				text: {
					project_id: inputData.textData[0].project_id,
					count: inputData.textData[0].count,
					average: inputData.textData[0].avg_word_count,
					max: inputData.textData[0].max_word_count,
					min: inputData.textData[0].min_word_count,
				},
			};
		}
		return {
			audio: {
				project_id: this.projectID,
				count: 0,
				average: 0,
				max: 0,
				min: 0,
			},
			video: {
				project_id: this.projectID,
				count: 0,
				average: 0,
				max: 0,
				min: 0,
			},
			text: {
				project_id: this.projectID,
				count: 0,
				average: 0,
				max: 0,
				min: 0,
			},
		};
	}
	getAudioVideoMapData(item: any) {
		return {
			text: item.text_count,
			audio: item.audio_count,
			video: item.total_steam_count - item.audio_count,
		};
	}
}
